const DEAL_TYPE = 'Deal'
const PERSON_TYPE = 'Person'
const COMPANY_TYPE = 'Company'
const PROJECT_TYPE = 'Project'
const PROJECT_MILESTONE_TYPE = 'ProjectMilestone'

const DEFAULT_FIELDS = {
  [COMPANY_TYPE]: [
    'name',
    'owner',
    'phone1',
    'phone2',
    'phone3',
    'phone4',
    'fax',
    'email',
    'web',
    'address',
    'twitter',
    'facebook_url',
    'linked_in_url',
    'instant_message'
  ],
  [DEAL_TYPE]: [
    'name',
    'user'
  ],
  [PERSON_TYPE]: [
    'name',
    'owner',
    'position',
    'company_name',
    'phone',
    'home_phone',
    'mobile',
    'fax',
    'email',
    'email2',
    'home_email',
    'website',
    'work_address',
    'company_address',
    'home_address',
    'twitter',
    'facebook_url',
    'linked_in_url',
    'instant_message'
  ],
  [PROJECT_TYPE]: [
    'name',
    'owner',
    'status',
    'start_date',
    'end_date',
    'description',
    'project_milestones',
    'project_collaborators',
    'deals',
    'people',
    'companies',
    'counts'
  ],
  [PROJECT_MILESTONE_TYPE]: [
    'name',
    'status',
    'project',
    'start_date',
    'end_date'
  ]
}

export {
  DEAL_TYPE,
  PERSON_TYPE,
  COMPANY_TYPE,
  PROJECT_TYPE,
  PROJECT_MILESTONE_TYPE,
  DEFAULT_FIELDS
}
